/**
 * Quantidade na unidade de estoque do produto: quantidade comercial (unidade do documento) × fator de conversão.
 * O fator efetivo é 1 quando a unidade comercial é a mesma do produto (sem espaços nas pontas, sem diferenciar
 * maiúsculas nem acentos) ou quando o fator é nulo, zero ou negativo; senão, é o fator informado. Sem a unidade do
 * produto, vale o fator informado. Sem arredondar: só tira o ruído de ponto flutuante (`toPrecision(15)`); quem exibe
 * formata.
 * A recusa do item com unidade diferente e sem fator confirmado é validação da associação, não desta conta.
 * Par no servidor: ATS.Hub.Lib.Shared/Helpers/QuantidadeEstoqueProdutoHelper.cs.
 */

/** Fator de conversão efetivo da unidade comercial para a unidade de estoque do produto. */
export function obterFatorConversaoEfetivo(
  fatorConversao: number | null | undefined,
  unidadeComercial: string | null | undefined,
  unidadeProduto: string | null | undefined,
): number {
  const produto = normalizarUnidade(unidadeProduto);
  const isMesmaUnidade = produto.length > 0 && normalizarUnidade(unidadeComercial) === produto;
  if (isMesmaUnidade || !fatorConversao || fatorConversao <= 0) return 1;
  return fatorConversao;
}

/** Quantidade comercial × fator efetivo ({@link obterFatorConversaoEfetivo}), sem arredondar. */
export function calcularQuantidadeEstoque(
  quantidadeComercial: number,
  fatorConversao: number | null | undefined,
  unidadeComercial: string | null | undefined,
  unidadeProduto: string | null | undefined,
): number {
  const fator = obterFatorConversaoEfetivo(fatorConversao, unidadeComercial, unidadeProduto);
  return Number(((Number(quantidadeComercial) || 0) * fator).toPrecision(15));
}

/** Mesma normalização do modal de associação (sem caixa, acentos e espaços nas pontas). */
function normalizarUnidade(texto: string | null | undefined): string {
  return (texto ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').trim();
}
